import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { plantNcuDetailRoute } from "@/pages/PlantNcuDetail/route";

export const plantTcuDetailRoute = createRoute({
  path: "tcu/$tcuName",
  getParentRoute: () => plantNcuDetailRoute,
  staticData: { crumb: "tcu" },
  // Fuerza un remount completo al cambiar de TCU: el SSE de useSSE no resetea
  // su último dato al reconectar, así que sin esto el chip podía arrastrar un
  // instante el estado del TCU anterior.
  remountDeps: ({ params }) => params.tcuName,
  component: lazyRouteComponent(async () => {
    const m = await import("./GuardedPlantTcuDetail");
    return { default: m.GuardedPlantTcuDetail };
  }),
});
